<!--
  --
  -- 支払方法 アイテム コンポーネント
  --
  -->
<template>
  <v-expansion-panel>
    <!-- header -->
    <v-expansion-panel-header>
      <!-- カード情報 -->
      <c-payment-summary :payment="payment"/>
    </v-expansion-panel-header>

    <!-- content -->
    <v-expansion-panel-content>
      <v-row no-gutters align="end">
        <v-col>
          <!-- 名義など -->
          <c-payment-detail :payment="payment"/>
        </v-col>

        <v-col cols="auto">
          <!-- 支払方法への操作 -->
          <div class="py-2">
            <slot name="itemActions"/>
          </div>
        </v-col>
      </v-row>
    </v-expansion-panel-content>

  </v-expansion-panel>
</template>

<script>
import CPaymentSummary from './CPaymentSummary'
import CPaymentDetail from './CPaymentDetail'

export default {
  name: 'CPaymentItem',
  components: {
    CPaymentSummary,
    CPaymentDetail
  },
  props: {
    payment: {
      type: Object,
      required: true
    }
  }
}
</script>
